import { useState, useEffect, useCallback } from "react";
import { orderService } from "../services/OrderService";
import { toast } from "react-hot-toast";

export const useOrdersPolling = (initialPollingInterval = 10000) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchOrders = useCallback(async () => {
    try {
      const result = await orderService.listOrders();

      if (result.success) {
        const formattedOrders = orderService.formatOrders(result.data);

        // Comparar si hay cambios antes de actualizar el estado
        const hasChanges =
          JSON.stringify(formattedOrders) !== JSON.stringify(orders);

        if (hasChanges) {
          setOrders(formattedOrders);
          setLastUpdate(new Date());

          // Si no es la carga inicial, mostrar notificación
          if (!isLoading) {
            toast.success("Se han actualizado las órdenes");
          }
        }
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Error al cargar las órdenes");
      console.error("Error fetching orders:", err);
    } finally {
      setIsLoading(false);
    }
  }, [orders, isLoading]);

  // Efecto para la carga inicial y configuración del polling
  useEffect(() => {
    fetchOrders(); // Carga inicial

    // Configurar el intervalo de polling
    const intervalId = setInterval(fetchOrders, initialPollingInterval);

    // Cleanup function
    return () => {
      clearInterval(intervalId);
    };
  }, [fetchOrders, initialPollingInterval]);

  // Función para forzar una actualización manual
  const refreshOrders = () => {
    setIsLoading(true);
    return fetchOrders();
  };

  return {
    orders,
    isLoading,
    error,
    lastUpdate,
    refreshOrders,
  };
};
